import { render } from "./GitHubInfo.vue?vue&type=template&id=744d7736&scoped=true"
import script from "./GitHubInfo.vue?vue&type=script&lang=js"
export * from "./GitHubInfo.vue?vue&type=script&lang=js"

import "./GitHubInfo.vue?vue&type=style&index=0&id=744d7736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744d7736"]])

export default __exports__